export default __webpack_public_path__ + "static/media/Right.a0ee8039.svg";